export enum MessageSeverity {
    Error,
    Warning,
    Info,
    Success
}
